module.exports = __webpack_public_path__ + "app-store-icon-41bb2669b7b0db8a1d6c.png";